import React, { FC } from "react";
import { useTranslation } from "react-i18next";

const PathErrorPage: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="page-content">
      <h1>{t("pathError.title")}</h1>
      <p>{t("pathError.text")}</p>
    </div>
  );
};

export default PathErrorPage;
